module.exports = __webpack_public_path__ + "static/media/beef6.bb13b313.jpeg";